export const convertPriceToText = (
  priceInt: number | null | undefined,
  unit?: string,
) => {
  if (priceInt === null || priceInt === 0) {
    return '-';
  }

  if (priceInt && unit) {
    return `$${priceInt.toLocaleString()} ${unit}`;
  }

  return `$${priceInt?.toLocaleString()}`;
};
